import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';
export interface ShareToneCSSStyle extends UIComponentCSSStyle
{
    getContentDivCSSStyle():object;
    getContentImageCSSStyle():object;
    getImageTitleCSSStyle():object;

   
}

export class ShareToneCSSStyleImpl extends UIComponentCSSStyleImpl implements ShareToneCSSStyle
{
    
    getWrapperCSSStyle(): object
    {
        return {
            height: "auto",
            width: "100%",
            borderRadius: "8px",
            paddingBottom:'30px',
            backgroundColor: this.getResources().getColor(Colors.color_5),
            justifyContent:'center',
            textAlign:'center'
        };
    }

    getContentDivCSSStyle(): object 
    {
        return{
            width:'93px',
            display:"inline-block",
            align:"center",
            height:'85px',
            margin:'30px 47.7px  0px 33.73px',
        };
    }

    getContentImageCSSStyle():object
    {
        return{
            width:"50px",
            height:'50px',
            cursor: "pointer",
            margin:'0px 21.5px 0px 21.5px'
        };
    }

    getImageTitleCSSStyle():object
    {
        return{
            width:"93px",
            height:'30px',
            fontSize:this.getResources().getFont(Fonts.h15),
            textAlign:'center',
            lineHeight:'30px',
            fontWeight:'bold',
            color:this.getResources().getColor(Colors.color_4),
            letterSpacing:'0px',
            fontFamily: this.getResources().getFontFamily()

        };
    }

   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/sharetone/sharetonecss.tsx